<template>
  <div class="wrap">
    <div class="payment">
      <div class="process">
        <div class="toast-box">{{ $t('User.Pickup.PickupFinish.msg1') }}</div>
      </div>

      <!-- 아래 요소 높이 일정해야 함 -->
      <div class="payment__content">
        <!-- header -->
        <div class="layer__header">
          <div class="lyr-title">{{ $t('User.Pickup.PickupFinish.msg2') }}</div>
          <div class="ft-point">
            {{ $t('User.Pickup.PickupFinish.msg3') }}
          </div>
        </div>
        <!-- //header -->

        <div class="payment__body">
          <div class="ft--giant center">03</div>
          <span class="img-info"><img src="@/assets/images/order/artwork_idle_pickup_3d.gif"/></span>
          <div class="sub-txt">
            <em>{{ num }}</em
            ><span>{{ $t('User.Pickup.PickupFinish.msg4') }}</span>
          </div>
        </div>
      </div>
      <!-- //payment__content -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'pickupFinish',
  props: {
    pickupNum: Number,
  },
  watch: {
    pickupNum: (data) => {
      console.log(data);
    },
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  methods: {},
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      num: 5,
    };
  },
  mounted() {
    this.$changeDarkMode(this.darkModeYn);

    setInterval(() => {
      this.num--;
    }, 1000);

    setTimeout(() => {
      this.$router.replace('/user/idle');
    }, 5000);
  },
  components: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped></style>
